<div class="close-container">
  <mat-icon class="close-icon" (click)="dialogRef.close()"></mat-icon>
</div>
<div class="title title--lg dialog" mat-dialog-title>Search Results</div>
<div class="smallerText mat-radio-label-content">Location Information will not be published. It is used to assist in
  appropriate selection.</div>
  <div class="smallerText required-text mat-radio-label-content" *ngFor="let error of data.errors">
    {{error}}
  </div>
<mat-dialog-content>
  <mat-radio-group aria-label="Select an option" class="radio" [(ngModel)]="resident">
    <mat-radio-button [value]="newResident">
      <div class=" list-font">Add New Resident</div>
      <div class=" smallerText list-font">None of the residents below match. Please add a new one</div>
    </mat-radio-button>
    <mat-radio-button *ngFor="let item of data.residentList" [value]="item" [disabled]="!item.canSelect">
      <div class=" list-font">{{item.labelName}}</div>
      <div class=" smallerText list-font">{{formatCityState(item)}}</div>
      <div class="smallerText required-text" *ngIf="!item.canSelect && item.notSelectableReason">
        {{item.notSelectableReason}}<br>
      </div>
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="btn--inline dialog-btn-container">
    <button (click)="dialogRef.close()" class="btn btn--small btn--outline">Resident Not Found</button>
    <button (click)="addResident()" class="btn btn--small btn--solid btn--red">Add Resident</button>
  </div>
</mat-dialog-actions>
